import { createContext } from 'utils/react-helpers';

export const SnackbarStackedContext = createContext({
  name: 'SnackbarStackedContext',
  strict: false,
});
